import {React,useState} from 'react'
import './Somes.css'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
import Collapsible from 'react-collapsible';
const Iq2 = () => {
    return (
        <div className='container'>
                 <NavLink to='/category/Interview question/7'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Interview question/5'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'80px'}}>&lt;- Previous page </Button>
</NavLink>
<div class="concepts">
<a > Aptitude Concepts</a>
</div>
<div>
<h1 class="h1"style={{float:'left'}}> Aptitude Questions</h1>
<h3 style={{float:'right'}}> Topics: <b>HCF and LCM</b></h3>
</div>

<br /> <br /> <br /> <br />

<br />

<td>


<p class="pq">1) What is the HCF of 1095 and 1168?</p>
<ol class="pointsu">
<li className='list'>37</li>
<li className='list'>73</li>
<li className='list'>43</li>
<li className='list'>83</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='show answer'> 
<div id="workspace1"></div> 
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>By Division Method</p>
<img src="https://static.javatpoint.com/aptitude/images/hcf-and-lcm-q1.png" alt="Aptitude H.C.F and L.C.M"/>
<p>Therefore the HCF is 73</p>
</div> </Collapsible>
<br />

<p class="pq">2) Find the HCF of 210, 385, and 735.</p>
<ol class="pointsu">
<li className='list'>7</li>
<li className='list'>14</li>
<li className='list'>21</li>
<li className='list'>35</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='show answer'> 
<div id="workspace2"></div> 
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p><img src="https://static.javatpoint.com/aptitude/images/hcf-and-lcm-q2.png" alt="Aptitude H.C.F and L.C.M"/></p>
<p>210 = 2 x 5 x 3 x 7 x 1<br/>
385 = 5 x 7 x 11 x 1<br/>
735 = 5 x 7 x 3 x 7 x 1<br/> 
<strong>HCF</strong> = 5 x 7 = 35</p>
</div> </Collapsible>
<br />

<p class="pq">3) <img src="https://static.javatpoint.com/aptitude/images/hcf-and-lcm-q3.png" style={{margin:'5px 4px -12px 0px'}} alt="Aptitude H.C.F and L.C.M"/></p>
<p><img src="https://static.javatpoint.com/aptitude/images/hcf-and-lcm-q3_1.png" alt="Aptitude H.C.F and L.C.M"/></p>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='show answer'> 
<div id="workspace3"></div> 
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p><strong>Formula:</strong> <img src="https://static.javatpoint.com/aptitude/images/hcf-and-lcm-q3_2.png" style={{margin:'5px 4px -17px 0px'}} alt="Aptitude H.C.F and L.C.M"/></p>
<p><strong>HCF:</strong></p>
<p>2= 2 x 1<br/>
8= 2 x 2 x 2<br/>
64= 2 x 2 x 2 x 2 x 2 x 2<br/>
10= 2 x 5<br/>
<strong>HCF</strong> =2</p>
<p><strong>LCM:</strong></p>
<p><img src="https://static.javatpoint.com/aptitude/images/hcf-and-lcm-q3_3.png" alt="Aptitude H.C.F and L.C.M"/></p>
<p><strong>LCM</strong> = 3 x 3 x 3 x 3 = 81</p>
<p><img src="https://static.javatpoint.com/aptitude/images/hcf-and-lcm-q3_4.png" alt="Aptitude H.C.F and L.C.M"/></p>
</div> </Collapsible>
<br />

<p class="pq">4) What will be the HCF of 608, 544; 638, 783; and 425, 476 respectively?</p>
<ol class="pointsu">
<li className='list'>32, 29, 17</li>
<li className='list'>17, 32, 29</li>
<li className='list'>29, 32, 17</li>
<li className='list'>32, 17, 29</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='show answer'> 
<div id="workspace4"></div> 
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>First of all we have to write the numbers as product of the prime factor.<br/>
Prime factor of 608 = 2<sup>5</sup> * 19<br/>
i.e., </p>
<p><img src="https://static.javatpoint.com/aptitude/images/hcf-and-lcm-q4.png" alt="Aptitude H.C.F and L.C.M"/></p>
<p>And the prime factor of 544 = 2<sup>5</sup> * 17 <br/>
i.e., </p>
<p><img src="https://static.javatpoint.com/aptitude/images/hcf-and-lcm-q4_1.png" alt="Aptitude H.C.F and L.C.M"/></p>
<p>So, the HCF of 608 and 544 = common factor in both = 2<sup>5</sup> = 32 <br/>
Similarly, The prime factor of 638 = 2 * 11 * 29<br/>
The prime factor of 783 = 3* 3 * 3 * 29<br/>
So, the <strong>HCF of 638 and 783 = 29</strong> </p>
<p>Now, the prime factor of 425 = 5 * 5 * 17<br/>
The prime factor of 476 = 2*2*7*17<br/>
So, the <strong>HCF of 425 and 476 = 17</strong></p>
</div> </Collapsible>
<br />

<p class="pq">5) <img src="https://static.javatpoint.com/aptitude/images/hcf-and-lcm-q5.png" style={{margin:'5px 4px -12px 0px'}} alt="Aptitude H.C.F and L.C.M"/></p>
<p><img src="https://static.javatpoint.com/aptitude/images/hcf-and-lcm-q5_1.png" alt="Aptitude H.C.F and L.C.M"/></p>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='show answer'> 
<div id="workspace5"></div> 
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong><br/>
<strong>Formula:</strong><img src="https://static.javatpoint.com/aptitude/images/hcf-and-lcm-q5_2.png" style={{margin:'5px 4px -15px 0px'}} alt="Aptitude H.C.F and L.C.M"/></p>
<p><strong>LCM:  </strong><br/>
<img src="https://static.javatpoint.com/aptitude/images/hcf-and-lcm-q5_3.png" style={{margin:'5px 4px -15px 0px'}} alt="Aptitude H.C.F and L.C.M"/></p>
<p><strong>LCM</strong> = 2 x 2 x 5 = 20</p>
<p><strong>HCF:</strong></p>
<p>3=3 x 1<br/>
6=3 x 2 x 1<br/>
9=3 x 3 x 1<br/>
27=3 x 3 x 3 x 1<br/>
<strong>HCF</strong> =3<br/>
<strong>Formula:</strong><img src="https://static.javatpoint.com/aptitude/images/hcf-and-lcm-q5_4.png" style={{margin:'5px 4px -15px 0px'}} alt="Aptitude H.C.F and L.C.M"/></p>
</div> </Collapsible>
<br />


<p class="pq">6) If the HCF of two numbers is 27, and their sum is 216, find these numbers.</p>
<ol class="pointsu">
<li className='list'>27, 189</li>
<li className='list'>154, 162</li>
<li className='list'>108, 108</li>
<li className='list'>81, 189</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='show answer'> 
<div id="workspace1"></div> 
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>Let the numbers be 27x and 27y.</p>
<p>       Then, 27x + 27y = 216<br/>
27 (x+ y) = 216<br/>
(x + y) = 216/27<br/>
        X + y = 8</p>
<p>co-prime numbers with sum 8 are (1, 7) and (3, 5).</p>
<p>Therefore we can say that the required numbers are (27 x1, 27 x 7) and (27 x 3, 27x 5), i.e. (27, 189) and (81, 135).<br/>
Out of the above two answers, the given one in the answer is the pair (27, 189). </p>
</div> </Collapsible>
<br />

<p class="pq">7) Two numbers are in the ratio of 15:11. If the HCF of numbers is 13, find the numbers. </p>
<ol class="pointsu">
<li className='list'>75, 55</li>
<li className='list'>105, 77</li>
<li className='list'>15, 11</li>
<li className='list'>195, 143</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='show answer'> 
<div id="workspace2"></div> 
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>Let the two numbers are 15x and 11x <br/>
HCF = x <br/>
 x = 13<br/>
Therefore, the numbers are (15 x 13 and 11 x 13), i.e. 195 and 143.</p>
</div> </Collapsible>
<br />

<p class="pq">8) Find the greatest integer that divides 358, 376, and 334 and leaves the same remainder in each case.  </p>
<ol class="pointsu">
<li className='list'>6</li>
<li className='list'>7</li>
<li className='list'>8</li>
<li className='list'>9</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='show answer'> 
<div id="workspace3"></div> 
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>Take the difference between two numbers </p>
<p>376 - 358 = 18; <br/>
376 - 334 = 42; <br/>
358 - 334 = 24; </p>
<p>By taking the HCF of 18, 42, 24.</p>
<p>18 = 2 x3 x 3<br/>
42 = 2 x 3 x 7<br/>
24 = 2 x 2 x 2 x 3<br/>
HCF = 2 x 3 = 6</p>
<p>Hence the required number is 6.</p>
</div> </Collapsible>
<br />

<p class="pq">9) Three bells toll at intervals of 36 sec, 40 sec, and 48 sec respectively. They start singing together at a particular time. When will they toll next together? </p>
<ol class="pointsu">
<li className='list'>6 minutes</li>
<li className='list'>12 minutes</li>
<li className='list'>18 minutes</li>
<li className='list'>24 minutes</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='show answer'> 
<div id="workspace4"></div> 
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>Firstly find the LCM of 36, 40, and 48</p>
<p><img src="https://static.javatpoint.com/aptitude/images/hcf-and-lcm-q9.png" alt="Aptitude H.C.F and L.C.M"/></p>
<p><strong>LCM</strong> = 2 x 2 x 2 x 2 x 3 x 3 x 5 = 720 seconds</p>
<p>Hence, after 720 seconds or 12 minutes three bells will toll together.</p>
</div> </Collapsible>
<br />

<p class="pq">10) The LCM of two numbers is 7700, and their HCF is 11. If one of these numbers is 275, what is the other number?</p>
<ol class="pointsu">
<li className='list'>279</li>
<li className='list'>283</li>
<li className='list'>308</li>
<li className='list'>318</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='show answer'> 
<div id="workspace5"></div> 
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p><strong>Apply Formula:</strong> HCF x LCM = first number x Second number
         11 x 7700 = 275 x second number</p>
<p><img src="https://static.javatpoint.com/aptitude/images/hcf-and-lcm-q10.png" alt="Aptitude H.C.F and L.C.M"/></p>
</div> </Collapsible>
<br />
<br/>


<br />






<p class="pq">11) The LCM of two numbers is 8919, and their sum is 1000. The two numbers are:</p>
<ol class="pointsu">
<li className='list'>993 and 7</li>
<li className='list'>989 and 11</li>
<li className='list'>991 and 9 </li>
<li className='list'>987 and 13</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='show answer'> 
<div id="workspace1"></div> 
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>Let the two numbers be x and (1000 - x)</p>
<p>∴ x * (1000 - x) = 8919<br/>
&nbsp;&nbsp;&nbsp;&nbsp;            1000x - x<sup>2</sup> = 8919<br/>
&nbsp;&nbsp;&nbsp;&nbsp;           -x<sup>2</sup> + 1000x -8919 = 0<br/>
&nbsp;&nbsp;&nbsp;&nbsp;            -x<sup>2</sup> + ( 991 + 9)x - 8919 = 0<br/>
&nbsp;&nbsp;&nbsp;&nbsp;            -x<sup>2</sup> + 991x +9x - 8919 = 0<br/>
&nbsp;&nbsp;&nbsp;&nbsp;            -x(x - 991) + 9(x - 991) = 0<br/>
&nbsp;&nbsp;&nbsp;&nbsp; (x - 991) (-x + 9) = 0</p>
<p>∴ (x - 991) = 0<br/>
&nbsp;&nbsp;&nbsp;&nbsp;                        X = 991, and <br/>
&nbsp;&nbsp;&nbsp;&nbsp;              (-x + 9) = 0<br/>
&nbsp;&nbsp;&nbsp;&nbsp;              -x = -9<br/>
&nbsp;&nbsp;&nbsp;&nbsp;              X = 9<br/>
         So, the required numbers are 991 and 9.</p>
</div> </Collapsible>
<br />

<p class="pq">12) If the LCM of two numbers is 70 and their HCF is 2, find the numbers. </p>
<ol class="pointsu">
<li className='list'>2, 35</li>
<li className='list'>6, 70</li>
<li className='list'>4, 70</li>
<li className='list'>14, 10</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='show answer'> 
<div id="workspace2"></div> 
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p><strong>Apply Formula:</strong> HCF x LCM = First number x Second number<br/>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;   2 x 70 = 140 (product of two numbers)<br/>
The option D satisfies the given condition, as 14 * 10 = 140. So, the required numbers are 14 and 10. </p>
</div> </Collapsible>
<br />

<p class="pq">13) Three different containers contain 496 liters, 403 liters, and 713 liters of water, respectively. What is the capacity of the biggest container that can measure three different quantities evenly?</p>
<ol class="pointsu">
<li className='list'>1 liter</li>
<li className='list'>7 liters</li>
<li className='list'>31 liters</li>
<li className='list'>41 liters</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='show answer'> 
<div id="workspace3"></div> 
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong> For the capacity of the biggest container, we have to find the HCF. <br/>
           HCF:  By Long Division method <br/>
           First find the HCF of two numbers, 496 and 403 </p>
<p><img src="https://static.javatpoint.com/aptitude/images/hcf-and-lcm-q13.png" alt="Aptitude H.C.F and L.C.M"/></p>
<p>The HCF of 496 and 403 = 31<br/> 
Now find the HCF of 31 and 713</p>
<p><img src="https://static.javatpoint.com/aptitude/images/hcf-and-lcm-q13_1.png" alt="Aptitude H.C.F and L.C.M"/></p>
<p>HCF of 713 and 31 is 31 <br/>
So, the maximum capacity is 31 liters. </p>
</div> </Collapsible>
<br />

<p class="pq">14) The least number which when divided by 2, 3, 4, 5 and 6 leaves the same remainder 1 in each case. If the same number is divided by 7, it leaves no remainder. Find the number. </p>
<ol class="pointsu">
<li className='list'>231</li>
<li className='list'>301</li>
<li className='list'>371</li>
<li className='list'>441</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='show answer'> 
<div id="workspace4"></div> 
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>LCM of 2, 3, 4, 5, 6 </p>
<p><img src="https://static.javatpoint.com/aptitude/images/hcf-and-lcm-q14.png" alt="Aptitude H.C.F and L.C.M"/></p>
<p>LCM = 2 x 2 x 3 x 5 = 60</p>
 <p>Now, 60 x 1 + 1 = 61 is not divisible by 7</p>
<p>60 x 2 + 1 = 121 is not divisible by 7 </p>
<p> 60 x 5 + 1 = 301 is divisible by 7 </p>
<p>Hence 301 is the number.</p>
</div> </Collapsible>
<br />

<p class="pq">15) Which is the greatest three-digit number which when divided by 6, 9 and 12 leaves a remainder of 3 in each case?  </p>
<ol class="pointsu">
<li className='list'>975</li>
<li className='list'>996</li>
<li className='list'>939</li>
<li className='list'>903</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='show answer'> 
<div id="workspace5"></div> 
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>Greatest three digit number = 999<br/>
            LCM of 6, 9 and 12 </p>
<p><img src="https://static.javatpoint.com/aptitude/images/hcf-and-lcm-q15.png" alt="Aptitude H.C.F and L.C.M"/></p>
<p>LCM = 2 x 2 x 3 x 3 = 36</p>
<p>On dividing 999 by 36,</p>
<p>Remainder = 27.</p>
<p>	∴ The greatest three digit number divisible by 6, 9, and 12 </p>
<p>&nbsp; &nbsp;&nbsp;&nbsp;   = (999 - 27) = 972</p>
<p>As per the question, the required number is (972 + 3) = 975. </p>
</div> </Collapsible>
<br />
<br/>

<p class="pq">16) There are two numbers. HCF of both the numbers is 11, and their LCM is 693. If the first number is 77, find the second number?</p>
<ol class="pointsu">
<li className='list'>89</li>
<li className='list'>56</li>
<li className='list'>78</li>
<li className='list'>99</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='show answer'> 
<div id="workspace1"></div> 
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>The product of two numbers = HCF * LCM</p>
<p>Let the required number is = x</p>

<p>So, 77 * x = 11 * 693</p>
<p>Hence, x=99.</p>
</div> </Collapsible>
<br />

<p class="pq">17) Find the greatest number which divides 34, 90, and 104 and leaves the same remainder in each case. </p>
<ol class="pointsu">
<li className='list'>15</li>
<li className='list'>17</li>
<li className='list'>14</li>
<li className='list'>18</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='show answer'> 
<div id="workspace2"></div> 
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>Difference between numbers = 90-34 = 56, and 104- 90=14</p>
<p>HCF of 56 and 14 = 14</p>
<p>Hence, 14 is the largest number which divides the given number and leaves the same remainder in each case. </p>
</div> </Collapsible>
<br />

<p class="pq">18) What is the least multiple of 7 which when divided by 6, 9, 15, and 18 respectively, leaves 4 as the remainder in each case? </p>
<ol class="pointsu">
<li className='list'>364</li>
<li className='list'>255</li>
<li className='list'>385</li>
<li className='list'>266</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='show answer'> 
<div id="workspace3"></div> 
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>Take LCM of 6, 9, 15, and 18. Their LCM = 90<br/>
As per given information, (90* x+4)/7</p>
<p>(90 *x)/ 7 = ((7 * 12 *x) + 6x + 4)/7<br/>
Or, (7*12x)/7 + (6x + 4)/7</p>
<p>x=4 satisfy the condition. <br/>
Hence, the required number is 90 * 4 + 4 = 364.  </p>
</div> </Collapsible>
<br />

<p class="pq">19) Which least number should be subtracted from 1936 so that the resulting number, when divided by 9, 10, and 15, will leave the same remainder 8 in each case? </p>
<ol class="pointsu">
<li className='list'>39</li>
<li className='list'>38</li>
<li className='list'>37</li>
<li className='list'>36</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='show answer'> 
<div id="workspace4"></div> 
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>Take LCM of 9, 10, and 15. Their LCM is = 90</p>
<p>If the number 1936 is divided by 90, we get the remainder 46, but we need 8 as remainder.</p>
<p>Hence, the required number is 46 - 8 = 38. </p>
</div> </Collapsible>
<br />

<p class="pq">20) Find the least number which when divided by 5, 6, 7, and 8 leaves remainder 3, but when divided by 9 leaves remainder 0.</p>
<ol class="pointsu">
<li className='list'>843</li>
<li className='list'>1683</li>
<li className='list'>2523</li>
<li className='list'>3363</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='show answer'> 
<div id="workspace5"></div> 
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>Take LCM of 5, 6, 7, and 8. It will be = 840. </p>
<p>Let the number 840*x + 3 is completely divisible by 9 if the sum of digits is divisible by 9.</p>
<p>Let x= 2, the number will be 1683, and the sum of its digits is equals to 18 which is divisible by 9. So, the required number is 1683. </p>
</div> </Collapsible>
<br />
<br/>

<br/><br/>




<p class="pq">21) The LCM of two prime number x and y is 161. If x&gt;y, find the value of 15y-7x.</p>
<ol class="pointsu">
<li className='list'>-32</li>
<li className='list'>-56</li>
<li className='list'>38</li>
<li className='list'>74</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='show answer'> 
<div id="workspace1"></div> 
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p><strong>Note: The HCF of two prime numbers = 1</strong></p>
<p>LCM/HCF =161/1 =161<br/>
161=7 * 23<br/>
The ratio of numbers: 7: 23<br/>
Hence, the expression gives15 * 7 - 7 * 23 = -56 </p>
</div> </Collapsible>
<br />

<p class="pq">22) Find the smallest digit that will leave same remainder 4 in each case when divided by 12, 15, 20, and 54.</p>
<ol class="pointsu">
<li className='list'>454</li>
<li className='list'>540</li>
<li className='list'>544</li>
<li className='list'>450</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='show answer'> 
<div id="workspace2"></div> 
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>Take LCM of 12, 15, 20, and 54. It will be = 540. </p>
<p>ATQ, the remainder in each case = 4.</p>
<p>Hence, the required number = 540+4 = 544. </p>
</div> </Collapsible>
<br />

<p class="pq">23) What is the number nearest to 10000 which is exactly divisible by 3, 4, 5, 6, 7, and 8?  </p>
<ol class="pointsu">
<li className='list'>9956</li>
<li className='list'>10080</li>
<li className='list'>10096</li>
<li className='list'>9240</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='show answer'> 
<div id="workspace3"></div> 
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>Take LCM of 3, 4, 5, 6, 7, and 8. It will be = 840.</p>
<p>Now, 10000/840 = 760 (remainder).</p>
<p>840 - 760 = 80. If we add 80 in the given number, the number is exactly divisible by 840.</p>
<p>So, the required number is 10080.   </p>
</div> </Collapsible>
<br />







</td>
        </div>
    )
}

export default Iq2
